import { PropsWithChildren } from 'react'
import styles from '../assets/scss/components/section.module.scss'

export const Section: React.FC<PropsWithChildren> = ({ children }) => {
  return <section className={styles.section}>{children}</section>
}
